module.exports = __webpack_public_path__ + "img/industry-3.956cdb9a.jpg";